import $http from "../axios";

const state = {
  accesses: []
};

const getters = {
  accesses: state => {
    return state.accesses;
  },

  accessesReverse(state) {
    return JSON.parse(JSON.stringify(state.accesses)).reverse();
  }
};

const actions = {
  getAccesses({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `accesses?beginDate=${data.dates[0]}&endDate=${
            data.dates[1]
          }&storeId=${data.storeId}&skip=${data.skip}&limit=${
            data.limit
          }&filter=${data.filter}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ACCESSES", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  changeAccessStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("change-access-status", data)
        .then(res => {
          commit("CHANGE_ACCESS_STATUS", data);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_ACCESSES(state, payload) {
    state.accesses = payload.accesses;
  },
  CHANGE_ACCESS_STATUS(state, payload) {
    const index = state.accesses.findIndex(el => {
      return el._id === payload.accessId;
    });
    state.accesses[index].status = payload.status;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
